import EyeClosedIcon from '@/components/Icons/EyeClosed'
import EyeOpenIcon from '@/components/Icons/EyeOpen'
import { useState } from 'react'
import styles from './PasswordInput.module.css'

interface PasswordInputProps {
  id: string
  label: string
  placeholder: string
  value: string
  onChange: (value: string) => void
  className?: string
  error?: string | null
  isPassword?: boolean
}

const PasswordInput = ({ id, label, placeholder, value, onChange, className = '', error, isPassword = false }: PasswordInputProps) => {
  const [showPassword, setShowPassword] = useState(false)

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword)
  }

  return (
    <fieldset className={`${styles.fieldset} ${className}`}>
      <label className={styles.label} htmlFor={id}>
        {label}
      </label>
      <div className={styles.inputWrapper}>
        <input
          className={`${styles.input} ${error ? styles.inputError : ''}`}
          id={id}
          type={isPassword ? (showPassword ? 'text' : 'password') : 'text'}
          placeholder={placeholder}
          value={value}
          onChange={(e) => onChange(e.target.value)}
          autoComplete="off"
        />
        {isPassword && (
          <button
            type="button"
            className={styles.eyeButton}
            onClick={togglePasswordVisibility}
            aria-label={showPassword ? 'Hide password' : 'Show password'}
          >
            {!showPassword ? <EyeClosedIcon size={16} /> : <EyeOpenIcon size={16} />}
          </button>
        )}
      </div>
      {error && <p className={styles.errorText}>{error}</p>}
    </fieldset>
  )
}

export default PasswordInput
